/* eslint-disable no-unused-expressions */

// import React, { useEffect, useRef, useState } from "react";
//  import '../component/App.css'
// import { Link } from "react-router-dom";
// import { ToastContainer } from "react-toastify";
// import { Row, Table } from "antd";
// import "react-datepicker/dist/react-datepicker.css";
// import Datatable from "./dataTable";
// import DeleteModal from "../../../components/modelpopup/DeleteModal";
// import SearchBox from "../../../components/SearchBox";
// import LeaveFilter from "../../../components/LeaveFilter";
// import ApplicationModal from "./application";
// import {
//   LeaveDetails,
//   LeaveStatus,
//   TaskDetails,
// } from "../../Services/ApiCalling";
// import moment from "moment";
// import EmployeeLeave from "../../LeaveEmployee/component/EmployeeLeave";
// import { useNavigate } from 'react-router-dom';

// import Papa from 'papaparse';

// const AdminLeave = () => {

//   // State to store parsed CSV data from all files
//   const [fileData, setFileData] = useState([]);
//   const [csvData,setCsvData] = useState()
//   const [filenames,setFilenames] = useState()
//   // Function to fetch and parse all CSV files at once
//   const handleImportClick = async (e) => {
//     console.log("eeeeeeee",e.target.files)
//     const files = ['file1.csv', 'file2.csv', 'file3.csv','file4.csv','file5.csv']; // List of all files to import
//     let allData = []; // Array to accumulate all parsed data

//     const response = e.target.files[0]
//     //  await fetch('/data.csv'); // Fetch from public folder
//     // const reader = response.body.getReader();
//     // const decoder = new TextDecoder('utf-8');
//     // const result = await reader.read();
//     // const csvString = decoder.decode(response.value); // CSV as a string

//     if (response) {
//       Papa.parse(response, {
//         header: true,  // Parses the CSV as an array of objects
//         skipEmptyLines: true,  // Skips empty lines
//         complete: (result) => {
//           console.log("Parsed Data:", result.data);
//           setCsvData(result.data);  // Set the parsed CSV data to state
//         },
//         error: (error) => {
//           console.error("Error parsing CSV:", error);
//         }
//       });
//     }

//   };

//   // Progress indicator component
//   function ProgressIndicator() {
//     return (
//       <div className="progress-indicator">
//         <div className="step active">Data Collection</div>
//         <div className="step">Data Preprocessing and Transformation</div>
//         <div className="step">Segmentation</div>
//         <div className="step">Results</div>
//       </div>
//     );
//   }

//   // DataTable to display static data and parsed CSV data

//   // Footer with navigation to the next page
//   function Footer() {
//     const navigate = useNavigate();

//     const handleNextStep = () => {
//       navigate("/employees"); // Navigate to another route on button click
//     };

//     return (
//       <div className="footer">
//         <button className="prev-button">Previous Step</button>
//         <button className="next-button" onClick={handleNextStep}>Next Step</button>
//       </div>
//     );
//   }

//   return (
//     <div className="app-container">
//       <ProgressIndicator />
//       <div className="main-content">
//       <div className="import-section">
//         <h3>Import Data</h3>
//         {/* <button className="import-button" onClick={handleImportClick}>
//           Import All Files
//         </button> */}

//         <input className="import-button" type="file" multiple="true" onChange={(e)=>handleImportClick(e)} />

//         <div className="project-input">
//           <p>Project Name/input</p>
//           <ul>
//             <li>file1</li>
//             <li>file2</li>
//             <li>file3</li>
//           </ul>
//         </div>
//       </div>
//         <Datatable csvData={csvData} />
//       </div>
//       <Footer />
//     </div>
//   );
// };

// export default AdminLeave;

// import React, { useEffect, useState } from "react";
// import '../component/App.css';
// import { useNavigate } from 'react-router-dom';
// import Papa from 'papaparse';
// import Datatable from "./dataTable"; // Ensure Datatable component is designed to accept csvData and display it
// // import moduleName from 'module'
// // import datsheet from "../component/"
// const AdminLeave = () => {

//   // State to store parsed CSV data and filenames
//   const [fileData] = useState(['test-sheet.csv','test-sheet2.csv','test-sheet3.csv','test-sheet4.csv','test-sheet5.csv']);
//   const [csvData, setCsvData] = useState([]);  // Stores the content of the selected CSV file
//   const [filenames, setFilenames] = useState('test-sheet.csv');  // Stores the names of selected files
//   const [firstRender,setFirstRender] = useState(false)

//   // Function to handle CSV import
//   const handleImportClick = async (e) => {

//     console.log("inside handle",e)

//     // const filePath = `${process.env.PUBLIC_URL}/data.csv`;  // Path to file in public folder

//     // Fetch the file from the public folder

//     // console.log("responseresponse",response,csvText)
//     let newFilenames = [];
//     let allData = [];
//    if(!firstRender){

//     console.log("/csv-files/${filenames}",`/csv-files/${e}`)
//     const response = await fetch(`/csv-files/${e ? e : filenames}`);
//     const csvText = await response.text();
//      Papa.parse(csvText, {
//        header: true,  // Parse CSV with headers
//        skipEmptyLines: true,  // Skip empty lines
//        complete: (result) => {
//         //  console.log("Parsed Data:", result.data);
//          allData = [...allData, ...result.data];  // Add parsed data to array
//          setCsvData(allData);  // Set the parsed data for display in the table
//        },
//        error: (error) => {
//          console.error("Error parsing CSV:", error);
//        }
//      });
//    }else {
//     // const csvText = await response.text();
//     //  Loop through selected files and parse each one testtttt
//     // const files = e.target.files; // Get the selected files

//     //  Array.from(files).forEach((file) => {
//     //    newFilenames.push(file.name);  // Add filename to array

//     //    Papa.parse(csvText, {
//     //      header: true,  // Parse CSV with headers
//     //      skipEmptyLines: true,  // Skip empty lines
//     //      complete: (result) => {
//     //        console.log("Parsed Data:", result.data);
//     //        allData = [...allData, ...result.data];  // Add parsed data to array
//     //        setCsvData(allData);  // Set the parsed data for display in the table
//     //      },
//     //      error: (error) => {
//     //        console.error("Error parsing CSV:", error);
//     //      }
//     //    });
//     //  });

//    }

//     /////test -over

//     // Update the filenames state to display in the UI
//     setFilenames(newFilenames);
//   };

//   useEffect(()=>{
//     if(!firstRender){
//    handleImportClick()

//     }
//   },[])

//   // Progress indicator component
//   function ProgressIndicator() {
//     return (
//       <div className="col-xl-12">
//       <div className="card">
//         <div className="card-body">
//           <div className="progress-steps">
//             <div className="progress-item">
//               <div className="progress-circle bg-success"></div>
//               <p className="progress-label">Data Collection</p>
//             </div>

//             <div className="progress-item">
//               <div className="progress-circle bg-secondary"></div>
//               <p className="progress-label">Data Processing</p>
//             </div>

//             <div className="progress-item">
//               <div className="progress-circle bg-secondary"></div>
//               <p className="progress-label">Segmentation</p>
//             </div>

//             <div className="progress-item">
//               <div className="progress-circle bg-secondary"></div>
//               <p className="progress-label">Results</p>
//             </div>
//           </div>

//           {/* Progress Bar */}
//           <div className="progress">
//             <div
//               className="progress-bar bg-success"
//               style={{ width: "24%" }}
//               role="progressbar"
//               aria-valuenow={70}
//               aria-valuemin={0}
//               aria-valuemax={100}
//             />
//           </div>
//         </div>
//       </div>
//     </div>

//     );
//   }

//   // Footer with navigation to the next page
//   function Footer() {
//     const navigate = useNavigate();

//     const handleNextStep = () => {
//       navigate("/employees"); // Navigate to another route on button click
//     };

//     return (
//       <div className="footer">
//         <button className="prev-button">Previous Step</button>
//         <button className="next-button" onClick={handleNextStep}>Next Step</button>
//       </div>
//     );
//   }

//   return (
//     <div className="app-container">
//       <ProgressIndicator />
//       <div className="main-content">
//         <div className="import-section">
//           <h3>Import Data</h3>
//           <input
//             className="import-button"
//             type="file"
//             multiple
//             accept=".csv"
//             onChange={()=>{
//               setFirstRender(true)
//               handleImportClick}}
//           />

//           <div className="project-input">
//             <p><b>Imported Files:</b></p>
//             <ul>
//               {/* Display each imported file name */}
//               {fileData.map((filename, index) => (
//                 <li onClick={()=>{
//                   console.log(filename)
//                   setFilenames(filename)
//                   handleImportClick(filename)
//                 }}>{filename}</li>
//               ))}
//             </ul>
//           </div>
//         </div>

//         {/* DataTable to display parsed CSV data */}
//         <Datatable csvData={csvData} />

//       </div>
//       <Footer />
//     </div>
//   );
// };

// export default AdminLeave;

// import React, { useEffect, useState } from "react";
// import '../component/App.css';
// import { useNavigate } from 'react-router-dom';
// import Papa from 'papaparse';
// import Datatable from "./dataTable"; // Ensure Datatable component is designed to accept csvData and display it

// const AdminLeave = () => {
//   // State to store parsed CSV data and filenames
//   const [fileData, setFileData] = useState(['test-sheet.csv', 'test-sheet2.csv', 'test-sheet3.csv', 'test-sheet4.csv', 'test-sheet5.csv']);
//   const [csvData, setCsvData] = useState([]);  // Stores the content of the selected CSV file
//   const [filenames, setFilenames] = useState('test-sheet.csv');  // Stores the names of selected files
//   const [firstRender, setFirstRender] = useState(false);

//   // Function to handle CSV import
//   const handleImportClick = async (e) => {
//     console.log("inside handle", e);
//     let allData = [];

//     if (!firstRender) {
//       console.log(`/csv-files/${filenames}`, `/csv-files/${e}`);
//       const response = await fetch(`/csv-files/${e ? e : filenames}`);
//       const csvText = await response.text();
//       Papa.parse(csvText, {
//         header: true,  // Parse CSV with headers
//         skipEmptyLines: true,  // Skip empty lines
//         complete: (result) => {
//           allData = [...allData, ...result.data];  // Add parsed data to array
//           setCsvData(allData);  // Set the parsed data for display in the table
//         },
//         error: (error) => {
//           console.error("Error parsing CSV:", error);
//         }
//       });
//     } else {
//       // Handle multiple files upload logic here
//     }
//   };

//   useEffect(() => {
//     if (!firstRender) {
//       handleImportClick();
//     }
//   }, []);

//   // Progress indicator component
//   function ProgressIndicator() {
//     return (
//       <div className="col-xl-12">
//         <div className="card">
//           <div className="card-body">
//             <div className="progress-steps">
//               <div className="progress-item">
//                 <div className="progress-circle bg-success"></div>
//                 <p className="progress-label">Data Collection</p>
//               </div>
//               <div className="progress-item">
//                 <div className="progress-circle bg-secondary"></div>
//                 <p className="progress-label">Data Processing</p>
//               </div>
//               <div className="progress-item">
//                 <div className="progress-circle bg-secondary"></div>
//                 <p className="progress-label">Segmentation</p>
//               </div>
//               <div className="progress-item">
//                 <div className="progress-circle bg-secondary"></div>
//                 <p className="progress-label">Results</p>
//               </div>
//             </div>

//             {/* Progress Bar */}
//             <div className="progress">
//               <div
//                 className="progress-bar bg-success"
//                 style={{ width: "24%" }}
//                 role="progressbar"
//                 aria-valuenow={70}
//                 aria-valuemin={0}
//                 aria-valuemax={100}
//               />
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   // Footer with navigation to the next page
//   function Footer() {
//     const navigate = useNavigate();

//     const handleNextStep = () => {
//       navigate("/employees"); // Navigate to another route on button click
//     };

//     return (
//       <div className="footer">
//         <button className="prev-button">Previous Step</button>
//         <button className="next-button" onClick={handleNextStep}>Next Step</button>
//       </div>
//     );
//   }

//   return (
//     <div className="app-container">
//       <ProgressIndicator />
//       <div className="main-content">
//         <div className="import-section">
//           <h3>Import Data</h3>

//           {/* Custom Import Button */}
//           <label className="import-button">
//             Import
//             <input
//               type="file"
//               multiple
//               accept=".csv"
//               onChange={(event) => {
//                 setFirstRender(true);
//                 const files = Array.from(event.target.files);
//                 const fileList = files.map(file => file.name);
//                 setFileData(fileList); // Update the list of file names
//                 handleImportClick(files[0]?.name); // Trigger the import function for the first file
//               }}
//             />
//           </label>

//           <div className="project-input">
//             <p><b>Imported Files:</b></p>
//             <ul>
//               {/* Display each imported file name */}
//               {fileData.map((filename, index) => (
//                 <li key={index} onClick={() => {
//                   setFilenames(filename);
//                   handleImportClick(filename);
//                 }}>
//                   {filename}
//                 </li>
//               ))}
//             </ul>
//           </div>
//         </div>

//         {/* DataTable to display parsed CSV data */}
//         <Datatable csvData={csvData} />
//       </div>
//       <Footer />
//     </div>
//   );
// };

// export default AdminLeave;

import React, { useEffect, useState } from "react";
import "./App.css";
import { useNavigate } from "react-router-dom";
import Papa from "papaparse";
import Datatable from "./dataTable";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

import ProgressIndicator from "./progressIndicator"; // Ensure Datatable component is designed to accept csvData and display it

const AdminLeave = () => {
  // State to store parsed CSV data and filenames
  const [fileData, setFileData] = useState([
    "READING_202301.csv",
    "READING_202302.csv",
    "READING_202303.csv",
    "READING_202304.csv",
    "READING_202305.csv",
    "READING_202306.csv",
    "READING_202307.csv",
    "READING_202308.csv",
    "READING_202309.csv",
    "READING_202310.csv",
    "READING_202311.csv",
  ]);
  const [csvData, setCsvData] = useState([]); // Stores the content of the selected CSV file
  const [filenames, setFilenames] = useState("READING_202301.csv"); // Stores the names of selected files
  const [firstRender, setFirstRender] = useState(false);

  // Function to handle CSV import
  const handleImportClick = async (e) => {
    console.log("inside handle", e);
    let allData = [];

    if (!firstRender) {
      console.log(`/csv-files/${filenames}`, `/csv-files/${e}`);
      const response = await fetch(`/csv-files/${e ? e : filenames}`);
      const csvText = await response.text();
      Papa.parse(csvText, {
        header: true, // Parse CSV with headers
        skipEmptyLines: true, // Skip empty lines
        complete: (result) => {
          allData = [...allData, ...result.data]; // Add parsed data to array
          setCsvData(allData); // Set the parsed data for display in the table
        },
        error: (error) => {
          console.error("Error parsing CSV:", error);
        },
      });
      // location.SHOWDATA = true
    } else {
      // Handle multiple files upload logic here
    }
  };

  useEffect(() => {
    if (!firstRender) {
      handleImportClick();
    }
  }, []);

  // Progress indicator component

  // Footer with navigation to the next page
  function Footer() {
    const navigate = useNavigate();

    const handleNextStep = () => {
      navigate("/data-processing"); // Navigate to another route on button click
    };

    return (
      <div className="footer">
        <button className="prev-button">
          <FaArrowLeft style={{ marginRight: "8px" }} />
          Previous Step
        </button>
        <button className="next-button" onClick={handleNextStep}>
          Next Step <FaArrowRight style={{ marginLeft: "8px" }} />
        </button>
      </div>
    );
  }

  return (
    // <div className="app-container">
    <div className="page-wrapper">
      <div className="content container-fluid">
        <ProgressIndicator />
        <div className="main-content">
          <label className="import-button">
            <i
              className="fas fa-file-import"
              style={{ marginRight: "8px" }}
            ></i>{" "}
            {/* Icon added */}
            Import Data
            <input
              type="file"
              multiple
              accept=".csv"
              onChange={(event) => {
                setFirstRender(true);
                const files = Array.from(event.target.files);
                const fileList = files.map((file) => file.name);
                setFileData(fileList); // Update the list of file names
                handleImportClick(files[0]?.name); // Trigger the import function for the first file
              }}
            />
          </label>
          <br></br>
          <br></br>
          <div className="row">
            <div className="col-md-6">
              <div className="card">
                <div className="cards-body">
                  {/* Custom Import Button with Icon */}

                  <div className="project-input">
                    <p>
                      <b>Project Name/Input</b>
                    </p>
                    <ul>
                      {/* {console.log("location?.state?.SHOWDATA",location?.state?.SHOWDATA)} */}
                      {/* Display each imported file name */}
                      {fileData.map((filename, index) => (
                        <li
                          key={index}
                          onClick={() => {
                            setFilenames(filename);
                            handleImportClick(filename);
                          }}
                        >
                          {filename}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              {/* DataTable to display parsed CSV data */}
              <Datatable csvData={csvData} />
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default AdminLeave;
